import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import defaultFrameImage from '../../../assets/images/frame.jpg';

const PageBanner = ({ title, description, backgroundImage = defaultFrameImage, children }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        borderRadius: '24px',
        p: { xs: 3, sm: 3.5, md: 3.5 },
        mb: 3,
        overflow: 'hidden',
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2
      }}
    >
      <Box sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.15)',
        zIndex: 1
      }} />

      <Stack spacing={1} sx={{ position: 'relative', zIndex: 2 }}>
        <Typography
          variant="h3"
          sx={{
            color: '#fff',
            fontWeight: 700,
            letterSpacing: 0.2,
            fontSize: { xs: 19, sm: 22, md: 25 },
            fontFamily: 'Poppins, sans-serif'
          }}
        >
          {title}
        </Typography>
        {description && (
          typeof description === 'string' ? (
            <Typography
              variant="body1"
              sx={{
                color: 'rgba(255,255,255,0.95)',
                maxWidth: 700,
                fontFamily: 'Poppins, sans-serif',
                fontSize: { xs: 12.5, sm: 14 }
              }}
            >
              {description}
            </Typography>
          ) : (
            description
          )
        )}
      </Stack>

      {children && (
        <Box sx={{ position: 'relative', zIndex: 2 }}>
          {children}
        </Box>
      )}
    </Box>
  );
};

export default PageBanner;
